import CrmStagesAPI from 'dashboard/api/crmStages';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getStages: $state => $state.records,
  getActiveStages: $state => $state.records.filter(s => s.active),
  getUIFlags: $state => $state.uiFlags,
  getStageById: $state => id => $state.records.find(s => s.id === id),
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmStagesAPI.get(params);
      commit('SET_STAGES', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, stageData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await CrmStagesAPI.create(stageData);
      commit('ADD_STAGE', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...stageData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmStagesAPI.update(id, stageData);
      commit('UPDATE_STAGE', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, payload) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      const stageId = typeof payload === 'object' ? payload.id : payload;
      const deleteParams =
        typeof payload === 'object' && payload.moveToStageId
          ? { move_to_stage_id: payload.moveToStageId }
          : {};

      await CrmStagesAPI.delete(stageId, deleteParams);
      commit('DELETE_STAGE', stageId);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async reorder({ commit }, stages) {
    try {
      const { data } = await CrmStagesAPI.reorder(stages);
      commit('SET_STAGES', data.payload);
    } catch (error) {
      throw error;
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  SET_STAGES($state, stages) {
    $state.records = stages;
  },
  ADD_STAGE($state, stage) {
    $state.records.push(stage);
  },
  UPDATE_STAGE($state, stage) {
    const index = $state.records.findIndex(s => s.id === stage.id);
    if (index !== -1) {
      $state.records.splice(index, 1, stage);
    }
  },
  DELETE_STAGE($state, id) {
    $state.records = $state.records.filter(s => s.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
